import React from "react";
import { LicenseWarningIcon } from "@rl-appliances/component-library";
import useLocalLicense from "../hooks/useLocalLicense";

const LicenseWarning = () => {
  const { localLicense, isLocalLicenseExpiring, isLocalLicenseValidOrOnline } =
    useLocalLicense();

  const message = `Spectra Intelligence is not available or licence is expiring. Valid until: ${
    localLicense?.expiryDate ?? "-"
  }`;

  return isLocalLicenseExpiring && isLocalLicenseValidOrOnline ? (
    <div className={"licensing-warning-icon-container"}>
      <LicenseWarningIcon statusMessage={message} tooltipPlacement="bottom" />
    </div>
  ) : null;
};

export default LicenseWarning;
